var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    color: "currentColor"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,71.8h56c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2H22c-1.1,0-2-0.9-2-2v-4C20,72.7,20.9,71.8,22,71.8z",
    color: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,53.8h56c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2H22c-1.1,0-2-0.9-2-2v-4C20,54.7,20.9,53.8,22,53.8z",
    color: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,35.8H78c1.1,0,2,0.9,2,2v4c0,1.1-0.9,2-2,2H57.6c-1.1,0-2-0.9-2-2v-4C55.6,36.7,56.5,35.8,57.6,35.8z",
    color: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6,44.4L38.1,21c-0.2-0.4-0.6-0.7-1.1-0.7h-7.2c-0.4,0-0.9,0.3-1,0.7L20,44.4c-0.1,0.4,0.1,1,0.7,1h4.6 c0.4,0,0.9-0.4,1-0.8l1.8-5l11.1,0l2,5c0.1,0.4,0.6,0.8,1,0.8h4.6C47.4,45.4,47.7,44.9,47.6,44.4z M30.2,33.6l2.9-7.4h0.6l3.2,7.4 H30.2z",
    color: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.7d2b0bb7d8d840252e8f8eefc604bc1d.svg";
export { ForwardRef as ReactComponent };